import { apiClient } from "@/api/api-client.ts";
import createBaseService from "@/api/base-service.ts";
import type { EvidenceNote, EvidenceNoteForm } from "../../types/evidence";

const evidenceNotesService = {
	...createBaseService<EvidenceNote>("/case-evidence-notes"),
	upsertById: async (data: EvidenceNoteForm) => {
		const response = await apiClient.post<{ data: EvidenceNoteForm }>("/case-evidence-notes", data, {
			headers: {
				"Content-Type": "multipart/form-data",
			},
		});

		return response.data.data;
	},
};

export default evidenceNotesService;
